var React = require('react');

function NewsBoldInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M7.34,9.11V26.76H28.52V9.11ZM26.62,24.85H9.24V11H26.62Z","key":1}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"19.3","width":"12.73","height":"1.06","key":2}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"21.64","width":"12.73","height":"1.06","key":3}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"13.35","width":"5.81","height":"4.28","key":4}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":5})]);
}

NewsBoldInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = NewsBoldInline;

NewsBoldInline.default = NewsBoldInline;
